// removed by extract-text-webpack-plugin
module.exports = {"frame":"_1Czr8EzqxqLV8WUJoo9jbh","balance":"_3n3so7E4VSPQarikHwy2D8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisWrapUnwrapWrap.scss
// module id = 1313
// module chunks = 0